import React, { Component, Fragment } from 'react';
import {convertTwoDecimalPoint, allowNumericWithdecimal, allowNumberWithDecimalNegative} from '../../../../server/util'
import NumberBox from '../../../Misc/NumericBox';
const packageFrequency={
    'ONETIME':'One Time',
    'WEEKLY':'Weekly',
    'MONTHLY':'Monthly'
}
const packageTypeOptions={'Enrollment':'Enrollment','Package':'Package'};
class Package extends Component {
    constructor(props){
        super(props)
        this.state={
            data:this.props.data,
            errors: {
                packageName: '',
                frequency: '',
                type :'',
                perAdditionalStdDiscountPerc:'',
                maxFeePerParent:'',
                price: '',
              }
        }
    }
    componentWillReceiveProps=(nextProps)=>{
        this.setState({data:nextProps.data});
    }
    checkError=(name,value)=>{
        switch (name) {
            case 'packageName': 
                return (value.trim()).length <= 0
                  ? 'Package name required!'
                  : '';
            case 'type': 
                return (value.trim()).length <= 0
                    ? 'Please select package type!'
                      : '';
            case 'frequency': 
                return (value.trim()).length <= 0
                    ? 'Please select frequency!'
                    : '';
            case 'price': 
                return (parseFloat(convertTwoDecimalPoint(value))) <= 0
                    ? 'Please enter price!'
                    : '';
            case 'perAdditionalStdDiscountPerc': 
                const val=parseFloat(convertTwoDecimalPoint(value));
                return  val>100
                        ? 'Please enter valid percentage (less than or equals to 100)!'
                        : '';
            default:
                return '';
          }
    }
    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;        
        const {data, errors} =this.state;
        data[name]=value;
        errors[name]=this.checkError(name,value);
        this.setState({errors:errors,data: data});
    }
    validateForm = (errors) => {
        let valid = true;
        Object.keys(errors).forEach(name => {
            if(errors[name].length > 0){
                valid = false;
            }
        });        
        return valid;
    };
    render() {
        const {errors, data}=this.state;
        return (
            <Fragment>
                <form className="form-horizontal" 
                onSubmit={(e)=>{
                    e.preventDefault();
                    const _errors=this.state.errors;
                    const _data=this.state.data;
                    Object.keys(_data).forEach(name => {
                        _errors[name]= this.checkError(name,_data[name]);
                    });
                    if(this.validateForm(_errors)) {
                        this.props.onSubmit(e, this.state.data);
                    }else{
                        this.setState({errors:_errors})
                    }
                }}>
                    <div className="form-group">
                        <label htmlFor="packageName" className="col-sm-4 control-label">Name *</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" maxLength="50"
                            id="packageName" name="packageName" value={data.packageName} placeholder="Package Name" 
                            onChange={this.handleChange} noValidate/>
                            {errors.packageName.length > 0 && 
                                <span className='text-danger'>{errors.packageName}</span>}
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="type" className="col-sm-4 control-label">Type *</label>
                        <div className="col-sm-7">
                            <select className="form-control" 
                            id="type" name="type" value={data.type} 
                            onChange={this.handleChange} noValidate>
                                <option key={-1} value=''></option>
                                {                                  
                                    Object.keys(packageTypeOptions).map((item,key)=>{
                                        if(this.props.hideEnrolment){
                                            if(item !==packageTypeOptions.Enrollment){
                                                return <option key={key} value={packageTypeOptions[item]} >{item}</option>
                                            }
                                        }else{
                                            return <option key={key} value={packageTypeOptions[item]} >{item}</option>
                                        }                                    
                                    })
                                }
                            </select>
                            {errors.type.length > 0 && 
                                <span className='text-danger'>{errors.type}</span>}
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="frequency" className="col-sm-4 control-label">Frequency *</label>
                        <div className="col-sm-7">
                            <select className="form-control" id="frequency" 
                            name="frequency" placeholder="Frequency" value={data.frequency} onChange={this.handleChange} noValidate>
                            <option key={0}></option>
                                {
                                    (packageTypeOptions.Enrollment===data.type)?
                                        <option key={0} value={packageFrequency.ONETIME}>{packageFrequency.ONETIME}</option>
                                        :null
                                }
                                {
                                    (packageTypeOptions.Package===data.type)?
                                        Object.keys(packageFrequency).map((item,i)=>{
                                            return <option key={i+1} value={packageFrequency[item]}>
                                                {packageFrequency[item]}
                                            </option>
                                        })
                                        :null
                                }                        
                            </select>
                            {errors.frequency.length > 0 && 
                                <span className='text-danger'>{errors.frequency}</span>}
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="price" className="col-sm-4 control-label">Price *</label>
                        <div className="col-sm-7">
                            <NumberBox type="text" className="form-control" maxLength="6" value={data.price} id="price" name="price"  
                            placeholder="" 
                            onChange={this.handleChange} 
                            //onKeyPress={(e)=>{ allowNumberWithDecimalNegative(e)}} 
                            //onKeyUp={(e)=>{allowNumberWithDecimalNegative(e)}} 
                            //onBlur={(e)=>{allowNumberWithDecimalNegative(e)}}    
                            noValidate/>
                            {errors.price.length > 0 && 
                                <span className='text-danger'>{errors.price}</span>}
                        </div>
                    </div>
                    {
                        (packageTypeOptions.Package===data.type)?
                        <div className="form-group">
                        <label htmlFor="perAdditionalStdDiscountPerc" className="col-sm-4 control-label">Additional Child Fee Discount (%) </label>
                        <div className="col-sm-7">
                            <NumberBox type="text" className="form-control" value={data.perAdditionalStdDiscountPerc } id="perAdditionalStdDiscountPerc" name="perAdditionalStdDiscountPerc"  
                            placeholder="" maxLength="6"
                            onChange={this.handleChange} 
                            //onKeyPress={(e)=>{ allowNumberWithDecimalNegative(e)}} 
                            //onKeyUp={(e)=>{allowNumberWithDecimalNegative(e)}} 
                            //onBlur={(e)=>{allowNumberWithDecimalNegative(e)}} 
                            />
                            {errors.perAdditionalStdDiscountPerc.length > 0 && 
                                <span className='text-danger'>{errors.perAdditionalStdDiscountPerc}</span>}
                        </div>
                    </div>:null
                    }
                    {
                        (packageTypeOptions.Enrollment===data.type)?<div className="form-group">
                        <label htmlFor="maxFeePerParent" className="col-sm-4 control-label">Maximum Fee Per Parent</label>
                        <div className="col-sm-7">
                            <NumberBox type="text" className="form-control" value={data.maxFeePerParent} id="maxFeePerParent" name="maxFeePerParent"  
                            placeholder="" maxLength="6"
                            onChange={this.handleChange} 
                            //onKeyPress={(e)=>{ allowNumberWithDecimalNegative(e)}} 
                            //onKeyUp={(e)=>{allowNumberWithDecimalNegative(e)}} 
                            //onBlur={(e)=>{allowNumberWithDecimalNegative(e)}}
                            />            
                        </div>
                    </div>:null

                    }
                    
                    
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10 text-right">
                            <button type="button" className="btn btn-danger btn-xs" onClick={(e)=>{
                                this.props.onCancel(e);
                            }}>Cancel</button>
                            <button type="submit" className="btn btn-success btn-xs">Submit</button>
                        </div>
                    </div>
                </form>
                
            </Fragment>
        )
    }
}
export default Package;



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/BcAc/ManagePackage/package.jsx